/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import SurveySystemDash from "../../components/SurveyDashboard";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const SurveyDashboard = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.surveySystemDashboard?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <SurveySystemDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default SurveyDashboard;
